import { memo } from 'react';
import { BzHeading } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { WATCHLIST_GRID_INDEX } from '../../utils/global_variables';


const TabPagesContent = ({ arrPages, scripDetails, handleSelectedPage, nActiveCard, strSearchActiveTab, ...props }) => {

    return (
        <>
            <Container data-testid='global-search-pages-result-element' fluid className='p-0 px-3'>
                {
                    arrPages && arrPages.length > 0 && arrPages.map((each, i) =>
                        <Row data-testid='global-search-page-result-element' style={{ border: nActiveCard === i ? 'solid 1px' : null }} tabindex={nActiveCard === i ? 0 : -1} id={'globalsearchCard' + strSearchActiveTab + i} className={`g-0 ${scripDetails?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) ? 'watchlist-active-scrip' : ''} px-3 py-2`} key={i} onClick={e => handleSelectedPage(e, each)}>
                            <Col md={11} className='d-flex align-items-center justify-content-start'>
                                <BzHeading className='font-medium font-size3 color-text text-uppercase'>{each.displayName}</BzHeading>
                            </Col>
                            <Col md={1} className='d-flex align-items-center justify-content-end'>
                                <div className='icon-16 icon-forward-arrow icon-dark'></div>
                            </Col>
                        </Row>
                    )
                }
            </Container>
        </>
    );
};

export default memo(TabPagesContent);